module.exports = __webpack_public_path__ + "img/cskm.c2eaefcd.svg";